import { anim, pv, stagger } from '../../../motion'
import { Shape } from '../../../primitives'
import { Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'

// Karten liegen erst als Stapel in der Mitte und werden dann auf ihre Plätze ausgeteilt
const LOOK = [
  { kind: 'sq', color: 'blue', rotate: -9 },
  { kind: 'dot', color: 'green', rotate: 5 },
  { kind: 'tri', color: 'yellow', rotate: -4 },
  { kind: 'sq', color: 'pink', rotate: 8 }
]

export default function CandTips() {
  const c = useCopy('tipps')

  return (
    <div className='cin-full'>
      <div className='cin-pad cin-pad--top'>
        <h2 className='cin-title'>
          <Words text={c.title} at={[0, 0.14]} />
        </h2>
      </div>

      <div className='ch-deck' style={anim({ at: [0.08, 0.16], y: 160 })}>
        {c.tips.map((t, i) => (
          <article
            key={t.title}
            className={`ch-tip ch-tip--${i}`}
            style={{
              ...pv('d', stagger(0.2, 0.12, 0.16, i)),
              '--r': `${LOOK[i].rotate}deg`
            }}
          >
            <Shape kind={LOOK[i].kind} color={LOOK[i].color} size={30} />
            <h3 className='ch-tip__title'>{t.title}</h3>
            <p className='ch-tip__text'>{t.text}</p>
          </article>
        ))}
      </div>
    </div>
  )
}
